import {
  SET_ACT_PROPERTY,
  ACT_ERROR,
  SET_ACT_CHECKLIST_ITEM,
  SET_ACT_CHECKLIST_INTERNAL_BREAKS_ITEM,
  SET_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM,
  DELETE_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM,
  UI_UPDATE_FROM_PARTNER,
  SET_ACT_CHECKLIST_ACCESSORIES
} from 'store/actions/act';
import { setValueObjectByField } from 'helpers/object';

export default {
  [SET_ACT_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },

  [ACT_ERROR]: (state, error) => {
    state.error = error;
  },

  // eslint-disable-next-line complexity
  [UI_UPDATE_FROM_PARTNER]: (state, { data, stepId }) => {
    const { risk } = data;
    const stateRisk = state.risk || {};
    stateRisk[stepId] = risk.documentsRequired || [];
    state.risk = stateRisk;
  },

  [SET_ACT_CHECKLIST_ITEM]: (state, { index, itemOption }) => {
    const checklist = state.checklistDocumentationAndEquip[index];
    checklist.values.forEach(checklistItemValue => {
      if (checklistItemValue.labelId === itemOption) {
        // eslint-disable-next-line no-param-reassign
        checklistItemValue.selected = 1;
      } else {
        // eslint-disable-next-line no-param-reassign
        checklistItemValue.selected = 0;
      }
    });
  },

  [SET_ACT_CHECKLIST_INTERNAL_BREAKS_ITEM]: (state, { checklistIndex, item, value }) => {
    const checklist = state.interiorDamage[checklistIndex];
    checklist.values.forEach(checklistItemValue => {
      if (checklistItemValue.labelId === item) {
        // eslint-disable-next-line no-param-reassign
        checklistItemValue.value = value;
      }
    });
  },

  [SET_ACT_CHECKLIST_ACCESSORIES]: (state, { item, value }) => {
    const checklist = state.checklistAccessories || [];
    checklist.map(itemList => {
      if (itemList.labelId === item) {
        // eslint-disable-next-line no-param-reassign
        itemList.value = value;
      }
      return itemList;
    });
  },

  [DELETE_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM]: (state, { part }) => {
    state.bodyDamage = state.bodyDamage.filter(item => item !== part);
  },

  [SET_ACT_CHECKLIST_EXTERNAL_BREAKS_ITEM]: (state, { part }) => {
    state.bodyDamage.push(part);
  }
};
